import script from "./ThemesSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemesSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ThemesSettings.scss?vue&type=style&index=0&id=6f143dbf&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f143dbf"]])

export default __exports__